import 'slick-carousel';

const initSingleProductSlider = () => {
  jQuery('.single-product-slider')
    .on('init', (e, slick) => {
      slick.$slider
        .parent()
        .find('.slider-info .current')
        .text(slick.currentSlide + 1);
      slick.$slider.parent().find('.slider-info .total').text(slick.$slides.length);
    })
    .on('beforeChange', (e, slick, prev, next) => {
      slick.$slider
        .parent()
        .find('.slider-info .current')
        .text(next + 1);

      const playVideo = slick.$slider.find('.video-play');

      if (playVideo.length) {
        const data = playVideo.data('player');

        if (data) data.stopVideo();
      }
    })
    .slick({
      infinite: true,
      fade: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      asNavFor: '.single-product-slider-nav',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            arrows: true,
            prevArrow: '<button class="slick-prev"><span class="icon-arrow-l"></span></button>',
            nextArrow: '<button class="slick-next"><span class="icon-arrow-r"></span></button>',
          },
        },
        {
          breakpoint: 768,
          settings: {
            arrows: false,
          },
        },
      ],
    });

  jQuery('.single-product-slider-nav').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.single-product-slider',
    arrows: true,
    vertical: true,
    focusOnSelect: true,
    prevArrow: '<button class="slick-prev"><span class="icon-arrow-l"></span></button>',
    nextArrow: '<button class="slick-next"><span class="icon-arrow-l"></span></button>',
  });
};

export default initSingleProductSlider;
